import BossModel from "@/models/BossModel";
import PublicImage from "@/models/PublicImage/PublicImage";

export default class Slide extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'platinum-widget/gallery/slide';

    /**
     *
     * @type {string}
     */
    static entity = 'platinumWidgetGallerySlides';

    static fields() {
		return {
            id: this.number(null).nullable(),
            platinum_widget_gallery_id: this.number(null).nullable(),
            horizontal_public_image_id: this.number(null).nullable(),
            vertical_public_image_id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            rank: this.number(null).nullable(),
            horizontalPublicImage: this.belongsTo(PublicImage, 'horizontal_public_image_id'),
            verticalPublicImage: this.belongsTo(PublicImage, 'vertical_public_image_id'),
        }
	}

    /**
     *
     * @param galleryId
     * @returns {*}
     */
    static fetchByGalleryId(galleryId) {
        return this.api()
            .where('platinum_widget_gallery_id', galleryId)
            .with(['horizontalPublicImage', 'verticalPublicImage'])
            .get(true);
    }

    HorizontalPublicImage(){
        return this.getRelated('horizontalPublicImage');
    }

    VerticalPublicImage(){
        return this.getRelated('verticalPublicImage');
    }
}
